// extracted by mini-css-extract-plugin
module.exports = {"header":"_1iHt0","title-label":"_13Dlb","titleLabel":"_13Dlb","close":"_2IRw9","red":"_7lxeA","blue":"_390-C","green":"_2ffSb","lightGreen":"_1Kfg8"};